import DOMPurify from "dompurify";

export const sanitizeHTML = (html) => {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["target", "rel", "style"],
  });
};
